import { render, staticRenderFns } from "./SaiquApplyGoodsList.vue?vue&type=template&id=78cc11b4&scoped=true&"
import script from "./SaiquApplyGoodsList.vue?vue&type=script&lang=js&"
export * from "./SaiquApplyGoodsList.vue?vue&type=script&lang=js&"
import style0 from "./SaiquApplyGoodsList.vue?vue&type=style&index=0&id=78cc11b4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78cc11b4",
  null
  
)

export default component.exports